import {Column, Entity, OneToMany} from "typeorm";
import {BaseEntity} from "@/modules/base/entity/BaseEntity";
import {Matchday} from "@/modules/competitions/entity";
import dayjs, {Dayjs} from "dayjs";
import {MonthEnum} from "@/modules/base/enums";
import {app} from "@/di";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";

@Entity()
export class Season extends BaseEntity {
  @OneToMany(() => Matchday, matchday => matchday.season)
  matchdays: Matchday[];

  @Column({type: "boolean"})
  current = false;

  @Column({type: "bigint"})
  currentDateRaw: Date;

  public incrementDay() {
    this.currentDate = this.currentDate.add(1, 'day');
  }

  get day() {
    return this.startDate.diff(this.currentDate, 'day');
  }

  get startDate(): Dayjs {
    let date = this.currentDateRaw
      ? this.currentDate.clone()
      : dayjs().utc().set('year', app.get(ConfigRepository).get('general.seasonStartYear') + 1);

    if (date.month() < MonthEnum.JULY) {
      date = date.subtract(1, 'year');
    }

    return date.month(MonthEnum.JULY).startOf('month').startOf('day');
  }

  get endDate(): Dayjs {
    let date = this.currentDateRaw ? this.currentDate.clone() : dayjs().utc();

    if (date.month() >= MonthEnum.JULY) {
      date = date.add(1, 'year');
    }

    return date.month(MonthEnum.JUNE).endOf('month');
  }

  get isLastDay(): boolean {
    return this.currentDate.isSame(this.endDate, 'day');
  }

  get currentDate(): Dayjs {
    return dayjs.utc(this.currentDateRaw);
  }

  set currentDate(date) {
    this.currentDateRaw = date.toDate();
  }

  static currentInstance: Season | null = null;

  static async unsetCurrent(): Promise<void> {
    this.currentInstance = null;
  }

  static async current(): Promise<Season> {
    // todo make it work, sometimes when evaluating the season is not singleton
    // if (!this.currentInstance) {
    this.currentInstance = await this
      .createQueryBuilder('season')
      .where('season.current = true')
      .getOneOrFail();
    // }

    return this.currentInstance;
  }
}
